module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Wood2-137ef5618cf8bb4758a7abd27086d64d.svg";